import React from 'react';

const Scrollbar = () => {
    return null;
}

export default Scrollbar;
